import * as Sentry from '@sentry/react'

const isDev = process.env.REACT_APP_ENV === 'dev'

const initialize = async () => {
    if (isDev) return

    await Sentry.init({
        dsn: 'https://0c58e4dc1c589cde3575c1591d825d84@o419471.ingest.us.sentry.io/4509059778150400',
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 1,
        debug: isDev,
        environment: process.env.REACT_APP_ENV,
    })
}

const sendError = (error, label, ...subLabel) => {
    let errorStr = ''
    if (label) errorStr += `[${label}]`
    if (subLabel) subLabel.forEach(sl => (errorStr += `[${sl}]`))
    errorStr += ' ' + error

    if (isDev) console.log(errorStr)
    else Sentry.captureMessage(errorStr)
}

const utils = {
    initialize,
    sendError,
}

export default utils
